import styled from "styled-components";

export const CloseButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
`;

export const ProviderOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 5px;
  row-gap: 7px;
  margin: 15px 0px;
`;

export const ProviderSelector = styled.div`
  display: inline-block;
  border-radius: 50px;
  background: ${({ isChecked, theme }) =>
    isChecked ? theme.text.title : "transparent"};
  color: ${({ isChecked, theme }) =>
    isChecked ? theme.text.inverse : theme.text.title};
  border: 1px solid
    ${({ isChecked, theme }) =>
      isChecked ? theme.text.inverse : theme.text.title};
  line-height: 1;
  font-size: 9px;
  font-weight: 400;
  text-align: center;
  padding: 7px 15px 6px;
  white-space: nowrap;
  cursor: pointer;
  text-transform: uppercase;
  font-family: "PP Formula";
`;

export const IconsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(24px, 1fr));
  column-gap: 7px;
  row-gap: 7px;
  padding-top: 15px;
  padding-left: 5px;
`;

export const SingleIconContainer = styled.span`
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.text.text};

    ${({ isSelected, theme }) => {
      if (isSelected) {
        return `
          background: ${theme.text.title} !important;
          color: ${theme.text.text}; !important;
          border-radius: 4px;
          margin: -5px;
          padding: 5px;
        `;
      }
    }}
  }

  &:hover svg {
    margin: -4px;
    padding: 4px;
    border-radius: 3px;
    background: #00000022;
  }
`;

export const MessageContainer = styled.div`
  color: ${({ theme }) => theme.text.text};
  font-size: 12px;
  text-align: center;
  padding-top: 5px;
  font-family: "PP Formula";
`;
